import {
	Header,
	RootContainer,
	SideBar,
	SideBarContainer,
} from '../LayoutClient/container.styles'
import { useDispatch, useSelector } from 'react-redux'
import Logo from '../../../src/assets/img/FullLogo_Transparent.png'
import MenuItems, {
	MenuProvider,
	useMenu,
} from '../LayoutClient/menu-item.component'
import { PUBLIC } from '../../api/base'
import React, { useState, useEffect } from 'react'
import { logoutAction } from '../../redux/auth'
import { useHistory, useLocation } from 'react-router'
import { logout } from '../../api/auth'
import { adminMenuItems, renderSubMenu } from './adminLayoutMenuItemsList'
import ChatSupportWidget from '../ChatSupportWidget/ChatSupportWidget'
import Footer from '../Footer/footer.component'
import { Menu } from 'lucide-react'
// Inner component that uses the menu context
function AdminLayout({ children, user }) {
	const history = useHistory()
	const dispatch = useDispatch()
	const location = useLocation()
	const token = useSelector((state) => state.auth.token)
	const refreshToken = useSelector((state) => state.auth.refreshToken)

	// Use the menu context
	const { activeItem, setActiveItem } = useMenu()

	useEffect(() => {
		const path = history.location.pathname
		let menuItem = ''
		let subItem = ''
		const searchParams = new URLSearchParams(location.search)
		const fromParam = searchParams.get('from')
		// Determine the active Menu Item (Top Level)
		switch (true) {
			// --- Clients ---
			case path.includes('/admin/clients'):
			case path === '/admin/archive/clients':
				menuItem = 'clients'
				break
			// --- Transporteurs ---
			case path.includes('/admin/transporteurs'):
				menuItem = 'transporteurs'
				break
			// --- Chauffeurs ---
			case path.includes('/admin/chauffeurs'):
				menuItem = 'chauffeurs'
				break
			// --- Administrateurs ---
			case path.includes('/admin/administrateurs'):
			case path.includes('/admin/archived'):
				menuItem = 'administrateurs'
				break
			// --- Commerciaux ---
			case path.includes('/admin/commerciaux'):
			case path.includes('/admin/commercant/new'):
			case path.includes('/admin/commerciaux/archived'):
				menuItem = 'commerciaux'
				break
			// --- Plate-forme ---
			case path.includes('/admin/plateforme'):
			case path.includes('/annulees/admin'):
			case path.includes('/terminer/admin'):
				menuItem = 'plate-forme'
				break
			// --- Comptabilité ---
			case path.includes('/admin/comptabilite'):
				menuItem = 'comptabilite'
				break
			// --- Prélèvement ---
			case path === '/admin/prelevement':
			case path === '/admin/failedcharge':
				menuItem = 'prelevement'
				break
			// --- Tarif ---
			case path === '/tarif':
				menuItem = 'tarif'
				break
			// --- Map ---
			case path === '/map':
				menuItem = 'map'
				break
			// --- Mon Compte ---
			case path === '/admin/account':
				menuItem = 'mon-compte'
				break
			case path === '/admin/test-panel':
				menuItem = 'admin-test-panel'
				break
			// --- Default ---
			default:
				menuItem = null
				break
		}

		// Determine the active Sub Menu Item (if applicable)
		switch (true) {
			// --- Clients Sub-items ---
			case path === '/admin/clients':
				subItem = 'mes-clients'
				break
			case path === '/admin/archive/clients':
				subItem = 'archived-clients'
				break

			// --- Transporteurs Sub-items ---
			case path === '/admin/transporteurs':
				subItem = 'transporteurs-old'
				break
			case path === '/admin/transporteurs/new':
				subItem = 'transporteurs-new'
				break
			case path === '/admin/transporteurs/delete':
				subItem = 'transporteurs-delete'
				break

			// --- Chauffeurs Sub-items ---
			case path === '/admin/chauffeurs':
				subItem = 'chauffeurs-1'
				break

			// --- Administrateurs Sub-items ---
			case path === '/admin/administrateurs':
				subItem = 'administrateurs-list'
				break
			case path === '/admin/administrateurs/new':
				subItem = 'administrateurs-new'
				break
			case path === '/admin/archived':
				subItem = 'administrateurs-archived'
				break

			// --- Commerciaux Sub-items ---
			case path === '/admin/commerciaux':
				subItem = 'commerciaux-list'
				break
			case path === '/admin/commercant/new':
				subItem = 'commerciaux-new'
				break
			case path === '/admin/commerciaux/archived':
				subItem = 'commerciaux-archived'
				break

			// --- Plate-forme Sub-items ---
			case path === '/admin/plateforme/commandes':
				subItem = 'plateforme-commandes'
				break
			case path === '/admin/plateforme/attribuer':
				subItem = 'plateforme-attribuer'
				break

			case /^\/admin\/commandes\/[a-f\d]{24}\/missions$/.test(path):
				subItem =
					fromParam === 'commandes'
						? 'plateforme-commandes'
						: fromParam === 'salon'
							? 'plateforme-salon'
							: 'plateforme-attribuer'
				break

			case path === '/admin/plateforme/salon':
				subItem = 'plateforme-salon'
				break
			case path === '/annulees/admin':
				subItem = 'plateforme-annulees'
				break
			case path === '/terminer/admin':
				subItem = 'plateforme-terminees'
				break
			case path === '/admin/plateforme/facturation':
				subItem = 'plateforme-facturation'
				break
			case path === '/admin/plateforme/anomalie-transport':
				subItem = 'plateforme-anomalie'
				break

			// --- Comptabilité Sub-items ---
			case path === '/admin/comptabilite/clients':
				subItem = 'comptabilite-clients'
				break
			case path === '/admin/comptabilite/transporteurs':
				subItem = 'comptabilite-transporteurs'
				break
			case path === '/admin/comptabilite/commerciaux':
				subItem = 'comptabilite-commerciaux'
				break

			// --- Prélèvement Sub-items ---
			case path === '/admin/prelevement':
				subItem = 'prelevement-list'
				break
			case path === '/admin/failedcharge':
				subItem = 'prelevement-failed'
				break

			// --- Default ---
			default:
				subItem = null
				break
		}

		// Set active menu item in context
		setActiveItem(subItem || menuItem)
	}, [history.location.pathname, setActiveItem])

	const handleLogout = async () => {
		try {
			const data = {
				userId: user._id,
				refreshToken,
			}
			await logout(data, token)
			dispatch(logoutAction())
			history.push('/login')
		} catch (error) {
			console.error('Logout error:', error)
			dispatch(logoutAction())
			history.push('/login')
		}
	}
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);

	useEffect(() => {
		if (isMobileMenuOpen && isMobile) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
		}
	}, [isMobileMenuOpen, isMobile]);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	};
	const handleMenuItemClick = (originalOnClick) => {
		return () => {
			if (originalOnClick) originalOnClick();
			if (isMobile) setIsMobileMenuOpen(false);
		};
	};
	return (
		<RootContainer>
			<Header>
				<div style={{ display: 'flex', alignItems: 'center' }}>

					{isMobile && (
						<button
							onClick={toggleMobileMenu}
							style={{
								background: 'none',
								border: 'none',
								cursor: 'pointer',
								padding: '0.5rem',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginRight: '1rem',
							}}
						>
							<Menu size={28} color="white" />
						</button>
					)}

					{!isMobile && <img
						style={{
							width: isMobile ? '8rem' : '12rem',
						}}
						alt="logo"
						src={Logo}
					/>}
				</div>
				<div
					style={{
						background: isMobile ? 'transparent' : '#50F5A9',
						paddingRight: isMobile ? '1rem' : '2rem',
						paddingLeft: isMobile ? '1rem' : '2rem',
						paddingTop: '0.5rem',
						paddingBottom: '0.5rem',
						borderRadius: '0.9rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-evenly',
						fontFamily: 'Montserrat',
						color: '#fff',
						fontWeight: 'bold',
						fontSize: isMobile ? '0.75rem' : '1rem',
					}}
				>
					{!isMobile && (
						<>
							{(user?.role === 'admin' || user?.role === 'super admin') && (
								<span>Bienvenue Admin</span>
							)}
							{user?.role === 'admin distribution' && (
								<span>Bienvenue dans notre service de distribution</span>
							)}
							{user?.role === 'admin service après vente' && (
								<span>Bienvenue dans notre service après vente</span>
							)}
							{user?.role === 'admin comptabilité' && (
								<span>Bienvenue dans notre service comptabilité</span>
							)}
							<span style={{ width: '10px' }} />
						</>
					)}

					<img
						style={{
							width: '2rem',
							height: '2rem',
							borderRadius: '1rem',
						}}
						alt="user"
						src={
							user && user.logo
								? `${PUBLIC}/${user.logo.name}`
								: 'https://secure.gravatar.com/avatar/6ee7af2da22737fd49ce56adc226d2cb?size=200&d=mp'
						}
					/>
				</div>
			</Header>

			<div
				style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'row',
					height: 'calc(100vh - 7rem)',
					position: 'relative',
				}}
			>
				{/* Mobile Overlay */}
				{isMobile && isMobileMenuOpen && (
					<div
						onClick={toggleMobileMenu}
						style={{
							position: 'fixed',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							background: 'rgba(0, 0, 0, 0.5)',
							zIndex: 998,
						}}
					/>
				)}

				{/* Sidebar with responsive positioning */}
				<div
					style={{
						position: isMobile ? 'fixed' : 'relative',
						left: isMobile ? (isMobileMenuOpen ? 0 : '-100%') : 0,
						top: isMobile ? 0 : 'auto',
						height: isMobile ? '100vh' : 'auto',
						transition: 'left 0.3s ease-in-out',
						zIndex: 999,
						width: isMobile ? '280px' : 'auto',
						overflowY: 'auto',
					}}
				>
					<SideBar>
						<SideBarContainer>
							{adminMenuItems
								.filter((item) => !item.hideWhen || !item.hideWhen(user))
								.map((item) => (
									<MenuItems
										key={item.id}
										id={item.id}
										title={item.title}
										active={
											activeItem === item.id ||
											(item.subMenu &&
												item.subMenu.some((sub) => sub.id === activeItem))
										}
										icon={item.icon}
										onClick={
											item.path
												? handleMenuItemClick(() => history.push(item.path))
												: item.action === 'logout'
													? handleMenuItemClick(handleLogout)
													: undefined
										}
										subMenu={
											item.subMenu ? (
												<>
													{renderSubMenu(
														item.subMenu,
														activeItem,
														user,
														(path) => {
															history.push(path);
															if (isMobile) setIsMobileMenuOpen(false);
														}
													)}
												</>
											) : undefined
										}
									/>
								))}
						</SideBarContainer>
					</SideBar>
				</div>

				<div
					style={{
						width: '100%',
						background: 'white',
						overflowY: user?.status === 'suspendu' ? 'hidden' : 'auto',
						position: 'relative',
					}}
				>
					{children}
					{user?.status === 'suspendu' && (
						<div
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								background: 'rgba(0, 0, 0, 0.5)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								zIndex: 100,
							}}
						>
							<div
								style={{
									width: isMobile ? '90%' : '50%',
									background: 'white',
									borderRadius: 5,
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									padding: '2rem',
									textAlign: 'center',
								}}
							>
								<span
									style={{
										fontFamily: 'Montserrat',
										fontSize: isMobile ? 18 : 20,
										marginBottom: '2rem',
										fontWeight: 'bold',
									}}
								>
									Compte suspendu
								</span>
								<span
									style={{
										fontFamily: 'Montserrat',
										fontSize: isMobile ? 14 : 16,
									}}
								>
									Votre compte est suspendu jusqu'à nouvelle ordre. Veuillez
									contacter la Plateforme du Transport pour plus d'informations.
									Merci.
								</span>
							</div>
						</div>
					)}
				</div>
			</div>
			<ChatSupportWidget />
			<Footer />
		</RootContainer>
	)
}

// Wrapper component that provides the menu context
function LayoutAdmin({ children }) {
	const user = useSelector((state) => state.auth.user)

	// Calculate initial open menus based on active path
	const getInitialOpenMenus = () => {
		const path = window.location.pathname
		const initialOpenMenus = {}

		// Logic to determine which menus should start open
		if (
			path.includes('/admin/clients') ||
			path === '/admin/archive/clients'
		)
			initialOpenMenus.clients = true
		if (path.includes('/admin/transporteurs'))
			initialOpenMenus.transporteurs = true
		if (path.includes('/admin/chauffeurs'))
			initialOpenMenus.chauffeurs = true
		if (
			path.includes('/admin/administrateurs') ||
			path.includes('/admin/archived')
		)
			initialOpenMenus.administrateurs = true
		if (
			path.includes('/admin/commerciaux') ||
			path.includes('/admin/commercant/new') ||
			path.includes('/admin/commerciaux/archived')
		)
			initialOpenMenus.commerciaux = true
		if (
			path.includes('/admin/plateforme') ||
			path.includes('/annulees/admin') ||
			path.includes('/terminer/admin') ||
			/^\/admin\/commandes\/[a-f\d]{24}\/missions$/.test(path)
		)
			initialOpenMenus['plate-forme'] = true
		if (path.includes('/admin/comptabilite'))
			initialOpenMenus.comptabilite = true
		if (
			path.includes('/admin/prelevement') ||
			path === '/admin/failedcharge'
		)
			initialOpenMenus.prelevement = true
		if (path === '/tarif') initialOpenMenus.tarif = true
		if (path === '/map') initialOpenMenus.map = true
		if (path === '/admin/account') initialOpenMenus['mon-compte'] = true

		return initialOpenMenus
	}

	// Determine initial active item
	const getInitialActiveItem = () => {
		const path = window.location.pathname
		const searchParams = new URLSearchParams(window.location.search)
		const fromParam = searchParams.get('from')
		// First, check for specific submenu paths

		// --- Clients Sub-items ---
		if (path === '/admin/clients') return 'mes-clients'
		if (path === '/admin/archive/clients') return 'archived-clients'

		// --- Transporteurs Sub-items ---
		if (path === '/admin/transporteurs') return 'transporteurs-old'
		if (path === '/admin/transporteurs/new') return 'transporteurs-new'
		if (path === '/admin/transporteurs/delete')
			return 'transporteurs-delete'

		// --- Chauffeurs Sub-items ---
		if (path === '/admin/chauffeurs') return 'chauffeurs-1'

		// --- Administrateurs Sub-items ---
		if (path === '/admin/administrateurs') return 'administrateurs-list'
		if (path === '/admin/administrateurs/new') return 'administrateurs-new'
		if (path === '/admin/archived') return 'administrateurs-archived'

		// --- Commerciaux Sub-items ---
		if (path === '/admin/commerciaux') return 'commerciaux-list'
		if (path === '/admin/commercant/new') return 'commerciaux-new'
		if (path === '/admin/commerciaux/archived')
			return 'commerciaux-archived'

		// --- Plate-forme Sub-items ---
		if (path === '/admin/plateforme/commandes')
			return 'plateforme-commandes'
		if (path === '/admin/plateforme/attribuer')
			return 'plateforme-attribuer'

		if (/^\/admin\/commandes\/[a-f\d]{24}\/missions$/.test(path)) {
			if (fromParam === 'commandes') {
				return 'plateforme-commandes'
			} else if (fromParam === 'salon') {
				return 'plateforme-salon'
			} else {
				return 'plateforme-attribuer'
			}
		}

		if (path === '/admin/plateforme/salon') return 'plateforme-salon'
		if (path === '/annulees/admin') return 'plateforme-annulees'
		if (path === '/terminer/admin') return 'plateforme-terminees'
		if (path === '/admin/plateforme/facturation')
			return 'plateforme-facturation'
		if (path === '/admin/plateforme/anomalie-transport')
			return 'plateforme-anomalie'

		// --- Comptabilité Sub-items ---
		if (path === '/admin/comptabilite/clients')
			return 'comptabilite-clients'
		if (path === '/admin/comptabilite/transporteurs')
			return 'comptabilite-transporteurs'
		if (path === '/admin/comptabilite/commerciaux')
			return 'comptabilite-commerciaux'

		// --- Prélèvement Sub-items ---
		if (path === '/admin/prelevement') return 'prelevement-list'
		if (path === '/admin/failedcharge') return 'prelevement-failed'

		// Then fallback to main menu items for broader path matches
		if (path.includes('/admin/clients')) return 'clients'
		if (path.includes('/admin/transporteurs')) return 'transporteurs'
		if (path.includes('/admin/chauffeurs')) return 'chauffeurs'
		if (
			path.includes('/admin/administrateurs') ||
			path.includes('/admin/archived')
		)
			return 'administrateurs'
		if (
			path.includes('/admin/commerciaux') ||
			path.includes('/admin/commercant/new')
		)
			return 'commerciaux'
		if (
			path.includes('/admin/plateforme') ||
			path.includes('/annulees/admin') ||
			path.includes('/terminer/admin')
		)
			return 'plate-forme'
		if (path.includes('/admin/comptabilite')) return 'comptabilite'
		if (
			path.includes('/admin/prelevement') ||
			path === '/admin/failedcharge'
		)
			return 'prelevement'
		if (path === '/tarif') return 'tarif'
		if (path === '/map') return 'map'
		if (path === '/admin/account') return 'mon-compte'

		return null
	}

	return (
		<MenuProvider
			initialOpenMenus={getInitialOpenMenus()}
			initialActiveItem={getInitialActiveItem()}
		>
			<AdminLayout user={user}>{children}</AdminLayout>
		</MenuProvider>
	)
}

export default LayoutAdmin
